/*jshint esversion: 6 */

import React from "react";

import classes from "./Input.css";
// import './Input.css';

const input = React.forwardRef((props, ref) => {
  let inputElement = null;
  // const inputClasses = [classes.InputElement];
  //const inputClasses = [InputElement];
  let validationError = null;

  if (props.invalid && props.shouldValidate && props.touched) {
    // inputClasses.push(Invalid);
    validationError = <p>Please enter a valid value</p>;
  }

  switch (props.elementType) {
    case "input":
      inputElement = (
        <input
          className={classes.InputElement}
          {...props.elementConfig}
          value={props.value}
          onChange={props.changed}
          ref={ref}
        />
      );
      break;
    case "textarea":
      inputElement = (
        <textarea
          className={classes.InputElement}
          {...props.elementConfig}
          value={props.value}
          onChange={props.changed}
        />
      );
      break;
    case "select":
      // console.log('Input select options:', props.elementConfig.options);
      inputElement = (
        <select
          className={classes.InputElement}
          value={props.value}
          onChange={props.changed}
        >
          {props.elementConfig.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.displayValue}
            </option>
          ))}
        </select>
      );
      break;
    default:
      inputElement = (
        <input className={classes.InputElement} value={props.value} />
      );
  }

  //console.log('Input inputElement:' + inputElement);
  return (
    <div className={classes.Input}>
      <label className={classes.Label}>{props.label}</label>
      {inputElement}
      {validationError}
    </div>
  );
});

export default input;
